module.exports = __webpack_public_path__ + "static/media/abyssal_underlord.b504f302.png";